export default __webpack_public_path__ + "static/media/pizza.2fff3ef5.jpg";